<template>
    <div class="fab-editor">
        <div class="options">
            <FabItem
                :value="fab"
                @input="(f) => updateFabItem(f, i)"
                v-for="(fab, i) of fabs"
                :key="fab.type + i"
                :icon-enabled="fabIconActive"
            />
        </div>
        <div class="preview">
            <FabPreview />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import FabItem from "./FabItem.vue";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
import FabPreview from "./FabPreview.vue";
import log2 from "../../../../utils/log2";

const log = log2("Settings/FabEditor");
export default {
    name: "FabEditor",
    components: {
        FabItem,
        FabPreview,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            enabledFabs: [],
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            isDarkMode: (state) => state.darkMode,
            fabIconActive: (state) => _.get(state.setting.settings, "fab.isFabsAsIcon"),
        }),
        fabs: {
            get() {
                return _.get(this.settings, "fab.items", []);
            },
            set(value) {
                log("fabs updated", value);
                this.updateSettings("fab.items", value);
            },
        },
    },
    methods: {
        updateFabItem(fab, i) {
            log("updateFabItem", fab, i);
            Vue.set(this.fabs, i, fab);
            this.updateSettings("fab.items", this.fabs);
        },
        isMailValid(email) {
            const validationControl = email == "" ? "" : this.reg.test(email) ? "has-success" : "has-error";
            this.validInput = validationControl === "has-success" ? "classs-success" : "classs-error";
            return this.validInput;
        },
        onSelect(e, type = undefined) {
            if (type !== undefined) {
                if (type === "whatsapp") {
                    this.fabs.find((x) => x.type === "whatsapp").callingCode = !!e && !!e.dialCode ? e.dialCode : "90";
                    this.fabs.find((x) => x.type === "whatsapp").country =
                        !!e && !!e.iso2 ? e.iso2.toLowerCase() : "tr";
                } else if (type === "phone") {
                    this.fabs.find((x) => x.type === "phone").callingCode = !!e && !!e.dialCode ? e.dialCode : "90";
                    this.fabs.find((x) => x.type === "phone").country = !!e && !!e.iso2 ? e.iso2.toLowerCase() : "tr";
                }
                this.updateSettings("fab.items", this.fabs);
                this.enablefabs = this.fabs.filter((x) => x.enable === true);
            }
        },

        fabInfoChanged(inputValue = undefined, type = "") {
            if (!!type && inputValue !== undefined) {
                if (type === "email") {
                    if (this.isMailValid(inputValue) === "classs-error")
                        this.$message.error(this.$t("message.emailIsNotCorrect"), 4);
                }
                if ((type === "whatsapp" || type === "phone") && inputValue.length < 12) {
                    if (type === "whatsapp") this.activeBorderWP = "1px solid red";
                    else if (type === "phone") this.activeBorderPhone = "1px solid red";
                    this.$message.error(this.$t("message.numberIsNotCorrect"), 4);
                }
            } else {
                if (!!type) {
                    if (type === "whatsapp") this.activeBorderWP = "1px solid #e5e5e5";
                    else if (type === "phone") this.activeBorderPhone = "1px solid #e5e5e5";
                }
            }
            this.updateSettings("fab.items", this.fabs);
        },
    },
};
</script>

<style scoped lang="scss">
.fab-editor {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .options {
        display: flex;
        flex-direction: column;
        gap: 5px;
        flex: 3;
    }

    .preview {
        flex: 1;
    }
}
</style>
